module.exports = __webpack_public_path__ + "static/media/realtor-1.406400ea.jpeg";